import React from 'react'
import cx from 'classnames'
import './Typography.scss'

const Paragraph = ({ center, children, className, gray, italic, left, onClick, small, white }) => (
    <p className={cx('paragraph', className, center && 'text-center', gray && 'heading-gray', italic && 'italic', left && 'text-left', small && 'small', white && 'heading-white')}
        onClick={e => onClick ? onClick(e) : null}>
        {children}
    </p>
)

export default Paragraph



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/typography/Paragraph.jsx